export default __webpack_public_path__ + "static/media/coach-murai.6ff44b90.png";